import React, { useEffect, useState } from "react";
import backicon from "./../../../../../../Assets/icons/backIcon.svg";
// import "./index.scss";
import { useLocation, useNavigate } from "react-router-dom";
import DynamicForm from "../../../../../customformComponent/customForm/DynamicForm";
import axiosInstance from "../../../../../services/api/API";
import Swal from "sweetalert2";
import Loader from "../../../../../customComponents/CustomLoader";
import ROUTES_NAVIGATION from "../../../../../../routes/routes";
import { addDays, addMonths, addYears } from "date-fns";

const EditExtendWarranty = () => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  const [validationErrors, setValidationErrors] = useState({});
  const [itemLabel, setItemLabel] = useState([]);
  const [itemtypedd, setItemTypeDD] = useState([]);
  const [warrantyTypeData, setWarrantyTypeData] = useState([]);
  const [itemTypeData, setItemTypeData] = useState([]);
  const location = useLocation();
  console.log("locationdataextwarranty",location);

  const [warrantycategory, setWarrantyCategory] = useState([]);

  useEffect(() => {
    warrantyType();
    warrantyCategory();
  }, []);
  const warrantyCategory = async () => {
    try {
      const response = await axiosInstance.post(
        "/warrantytype/ddlwarrantycategory",
        {},  // Add an empty object here for the request body
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

  
      const data = response.data.data.data;
      const warrantycategoryoptions = data.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));
      setWarrantyCategory(warrantycategoryoptions);
    } catch (error) {
      console.log(error);
    }
  };

  const warrantyType = async () => {
    try {
      const response = await axiosInstance.post(
        "/warrantytype/ddlwarrantytype",
        {},  // Add an empty object here for the request body
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
  
      const data = response.data.data.data;
      const warrantyTypeOptions = data.map((user) => ({
        value: user.ID,
        label: user.NAME,
      }));
      setWarrantyTypeData(warrantyTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };
  
  const extwarantyid=location?.state?.data?.extended_warranty_id
  const ItemListDropdown = async () => {
    try {
      const response = await axiosInstance.post(
        "/variant/ddltypebaseproduct",
        { itemtype_id: formData?.itemtype },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );

      const data = response.data.data.data;
      const itemTypeOptions = data.map((item) => ({
        value: item.ID,
        label: item.NAME,
      }));
      setItemTypeDD(itemTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    itemType();
  }, []);

  useEffect(() => {
    warrantyType();
    console.log("warrantyTypeData", warrantyTypeData);
  }, [formData?.item_id]);

  const itemType = async () => {
    try {
      const response = await axiosInstance.get("/itemtype/ddlitemtype", {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${authToken}`,
        },
      });

      const data = response.data.data.data;
      const itemTypeOptions = data.map((item) => ({
        value: item.ID,
        label: item.NAME,
      }));
      setItemTypeData(itemTypeOptions);
    } catch (error) {
      console.log(error);
    }
  };

  // const warrantyType = async () => {
  //   try {
  //     const response = await axiosInstance.post(
  //       "/variant/ddlproductbasewarrantydetail",
  //       { itemtype_id: formData?.itemtype, item_id: formData?.item_id },
  //       {
  //         headers: {
  //           "Content-Type": "application/json",
  //           Authorization: `Bearer ${authToken}`,
  //         },
  //       }
  //     );

  //     const data = response.data.data.data;
  //     console.log("warrantytypedata", data);
  //     setWarrantyTypeData(data);
  //     setFormData({
  //       ...formData,
  //       warrantycategory: data?.warranty_category_name,
  //       warrentytype: data?.warranty_type_name,
  //       warrentycategoryid: data?.warranty_category,
  //       warranty_type_id: data?.warranty_type,
  //     });
  //     console.log("warrantyformdata", formData);
  //   } catch (error) {
  //     console.log(error);
  //   }
  // };


  const navigate = useNavigate();
  const authToken = localStorage.getItem("authToken");
  const handleFormSubmit = async (formData) => {
    const errors = {};
    let isValid = true;
    CustomerInputs.forEach((field) => {
      if (field.validation && field.validation.required) {
        if (!formData[field.name]) {
          errors[field.name] = "This field is required";
          isValid = false;
        } else if (
          field.validation.pattern &&
          !field.validation.pattern.test(formData[field.name])
        ) {
          errors[field.name] = field.validation.message;
          isValid = false;
        }
      }
    });
    if (!isValid) {
      setValidationErrors(errors);
      return;
    }
    const confirmation = await Swal.fire({
      title: "Add Warranty",
      text: "Are you sure you want to add this record?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
    });
    if (confirmation.isConfirmed) {
      try {
        setLoading(true);

        const payload = {
          // extended_warranty_category: formData.warrentycategoryid,
          // itemtype_id: formData.itemtype,
          // item_id: formData.item_id,
          // extended_warranty_type: formData.warranty_type_id,
          // extended_warranty_name: formData.extwarrantyname,
          // extended_warranty_value: formData.warranty_value,
          // extended_warranty_desc: formData?.warranty_desc,
          // extended_warrantycost:formData?.extwarrantycost,
          extended_warranty_category: formData.warrantycategory,
          itemtype_id: formData.itemtype,
          item_id: formData.item_id,
          extended_warranty_type: formData.warrentytype,
          extended_warranty_name: formData.extwarrantyname,
          extended_warranty_value: formData.warranty_value,
          extended_warranty_desc: formData?.warranty_desc,
          extended_warrantycost: formData?.extwarrantycost,
          status: formData.status === true ? 1 : 0,
        };

        const response = await axiosInstance.patch(
          `/extendedwarranty/update/${extwarantyid}`,
          payload,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${authToken}`,
            },
          }
        );
        await Swal.fire({
          title: "Success",
          text: "Warranty added successfully!",
          icon: "success",
          confirmButtonText: "OK",
        });
        if (response.status === 200) {
          navigate(ROUTES_NAVIGATION.EXTENDWARRANTY);
        }
      } catch (error) {
        console.error("Error adding warranty:", error);
        const errorMessage =
          error.response?.data?.message ||
          "An error occurred while processing your request.";
        await Swal.fire({
          title: "Something went wrong",
          text: errorMessage,
          icon: "error",
          confirmButtonText: "OK",
        });
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
    }
  };

  const backNavigate = () => {
    navigate(ROUTES_NAVIGATION.EXTENDWARRANTY);
  };

  useEffect(() => {
    fetchExtWarranty();
  }, []);

  const fetchExtWarranty = async () => {
    try {
      const response = await axiosInstance.get(
        `/extendedwarranty/edit/${extwarantyid}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${authToken}`,
          },
        }
      );
      const fetchedData = response.data.data;
      console.log("fetchedData", fetchedData);
      const formatedData = {
        itemtype: fetchedData.itemtype_id,
        item_id: fetchedData.item_id,
        warranty_value:fetchedData?.extended_warranty_value ,
        extwarrantyname:fetchedData?.extended_warranty_name,
        warranty_desc:fetchedData?.extended_warranty_desc,
        extwarrantycost:fetchedData?.extended_warrantycost,
        status: fetchedData.status === 1 ? true : false,
        warrantycategory:fetchedData.extended_warranty_category,
        warrentytype:fetchedData.extended_warranty_type
      };
      setFormData(formatedData);
     
      console.log(formData, "notificationformdata");
    } catch (error) {
      console.log(error);
    }
  };  

  useEffect(() => {
    ItemListDropdown();
    setItemLabel(
      formData?.itemtype == 1
        ? "Spare Part"
        : formData?.itemtype == 2
        ? "Accessory"
        : "Variant"
    );
  }, [formData?.itemtype]);

  const CustomerInputs = [
    {
      name: "itemtype",
      label: "Item Type",
      type: "dropdown",
      required: true,
      options: itemTypeData,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "item_id",
      label: itemLabel,
      type: "dropdown",
      required: true,
      options: itemtypedd,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "warrantycategory",
      label: "Warranty Category",
      type: "dropdown",
      required: true,
      options: warrantycategory,
      placeholder: "Warranty Category",
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    ...(formData?.warrantycategory === "Y"
      ? [
          {
            name: "warrentytype",
            label: "Warranty Type",
            placeholder: "Enter Warranty Value",
            type: "dropdown",
          options: warrantyTypeData,
            required: true,
            validation: { required: true },
            gridClass: "col-lg-4",
          },
        ]
      : []),

    {
      name: "warranty_value",
      label: "Warranty Value",
      placeholder: "Enter Warranty Value",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "extwarrantyname",
      label: "Extended Warranty Name",
      placeholder: "Enter Extended Warranty Name",
      type: "text",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },

    {
      name: "warranty_desc",
      label: "Warranty Description",
      type: "text",
      placeholder: "Enter Warranty Description",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "extwarrantycost",
      label: "Extended Warranty Cost",
      type: "text",
      placeholder: "Enter Cost",
      required: true,
      validation: { required: true },
      gridClass: "col-lg-4",
    },
    {
      name: "status",
      label: "Status",
      type: "toggle",
      gridClass: "col-lg-4",
    },
  ];

  return (
    <>
      <div>
        {loading ? (
          <Loader />
        ) : (
          <>
            <div className="backbutton mt-2 mb-2">
              <img onClick={backNavigate} src={backicon} alt="back" />
              <span className="backbtntitle">Add Extended Warranty</span>
            </div>
            <div className="form-container">
              <span className="cust-det-title mt-2 mb-2">
                Please enter extended warranty details
              </span>
              <DynamicForm
                formConfig={CustomerInputs}
                formData={formData}
                setFormData={setFormData}
                onSubmit={handleFormSubmit}
                validationErrors={validationErrors}
                setValidationErrors={setValidationErrors}
              />
            </div>

            <div className="btncontainer mt-3">
              <button
                onClick={() => {
                  handleFormSubmit(formData);
                }}
                className="submit-btn"
              >
                Submit
              </button>
            </div>
          </>
        )}
      </div>
    </>
  );
};

export default EditExtendWarranty;
